/**
 * @author huancheng.zhan<huancheng.zhan@ukelink.com>
 * @description
 * @since 2018/3/7
 */

module.exports = file => () => import('@/views/' + file);



// WEBPACK FOOTER //
// ./src/router/_import.js